import axios from "axios";
import services from "@/config/services";

export default class LettureService {

    constructor (eventBus) {
        this.eventBus = eventBus;
        this.baseUrlFlussi = `${services.ask_flussi_api.url}`;
    }

    async getFileLettureEELogs(page = 1, perPage = 10, sortField = null, sortOrder = null) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione_ee/file/log`;
        const params = { page, per_page: perPage };

        if (sortField) params.sort_field = sortField;
        if (sortOrder) params.sort_order = sortOrder === 1 ? 'asc' : 'desc';

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async getFileLettureGasLogs(page = 1, perPage = 10, sortField = null, sortOrder = null) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione_gas/file/log`;
        const params = { page, per_page: perPage };
    
        if (sortField) params.sort_field = sortField;
        if (sortOrder) params.sort_order = sortOrder === 1 ? 'asc' : 'desc';
    
        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async downloadXmlFile(idFile, fileName, tipo, data) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione/xml/download`;

        try {
            const response = await axios.get(url, {
                params: { idFile, tipo, data },
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/xml' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

        } catch (err) {
            this.eventBus.emit("data-load-error", {
                message: err.response?.data || err.message,
                url
            });
        }
    }

    viewXmlFile(idFile, tipo, data) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione/xml/view?idFile=${idFile}&tipo=${tipo}&data=${data}`;
        window.open(url, '_blank');
    }

    async viewDownloadXmlFileFromGoogleBucket(idFile, tipo, data, mode = 'view') {
        const url = `${this.baseUrlFlussi}/letture_distribuzione/xml/view/from-google`;

        try {
            const response = await axios.get(url, {
                params: { idFile, tipo, data, mode }
            });

            if (response.data.length > 0) {
                window.open(response.data, '_blank');
            } else {
                alert('File non trovato');
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }
    
    async dettagliXmlFile(idFile, tipo) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione/xml/details`;

        try {
            const response = await axios.get(url, {
                params: { idFile, tipo }
            });
            return response.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async searchFiles(tipoRicerca, valoreDaCercare, tipoFornitura) {
        const url = `${this.baseUrlFlussi}/letture_distribuzione/cerca-flussi`;
        const params = { tipoRicerca, valoreDaCercare, tipoFornitura };

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }
}
